"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableDashboardLayoutSectionRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var dragAndDrop_1 = require("../../dragAndDrop");
var model_1 = require("../../../model");
var isHiddenStyle = { height: 0, width: 0, overflow: "hidden", flex: 0 };
var defaultStyle = {};
function useBorderStatus(sectionIndex) {
    var activeSectionIndex = model_1.useDashboardSelector(model_1.selectActiveSectionIndex);
    var isDraggingWidget = dragAndDrop_1.useIsDraggingWidget();
    if (isDraggingWidget) {
        return "muted";
    }
    var isActive = activeSectionIndex === sectionIndex;
    return !isActive ? "invisible" : "muted";
}
exports.EditableDashboardLayoutSectionRenderer = function (props) {
    var children = props.children, className = props.className, debug = props.debug, isHidden = props.isHidden, section = props.section;
    var style = isHidden ? isHiddenStyle : defaultStyle;
    var status = useBorderStatus(section.index());
    return (react_1.default.createElement("div", { className: classnames_1.default(["gd-fluidlayout-row", "s-fluid-layout-row", className], {
            "gd-fluidlayout-row-debug": debug,
        }), style: style },
        react_1.default.createElement(dragAndDrop_1.DashboardLayoutSectionBorder, { status: status }, children)));
};
//# sourceMappingURL=EditableDashboardLayoutSectionRenderer.js.map